import "@babel/polyfill"; // <- babel Polyfills
import "whatwg-fetch"; // <- Fetch API Polyfill

import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import App from "./Components/App/App.vue";
import config from "./../config";

const history = () => {
  try {
    localStorage.getItem("check");
    return true;
  } catch {
    return false;
  }
};

const lang = () => {
  if (history())
    return localStorage.getItem("lang") || config.app.fallback_lang;
  else {
    return config.app.fallback_lang;
  }
};

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

const app = createApp(App);
app.config.globalProperties.config = config;
app.config.globalProperties.history = history;
app.config.globalProperties.lang = lang;
app.use(router);
app.mount("#app");